import { KeyedMutator } from 'swr'
import {
  CampaignStepApiInterface,
  CampaignStepInterface,
} from 'modules/campaigns/campaign-steps/types/campaign-step-interface'

export const onMutateCampaignStepDataItem = async (
  mutate: KeyedMutator<CampaignStepApiInterface>,
  id: CampaignStepInterface['id'],
  newData: CampaignStepInterface,
) => {
  await mutate(data => {
    if (data) {
      return {
        items: data.items.map(item => {
          if (item.id === id) item = { ...item, ...newData }
          return item
        }),

        hasMore: data.hasMore,
      } as CampaignStepApiInterface
    }
  }, false)
}
